import React, { useEffect, useState } from "react";
import {
  Collapse,
  CollapseBody,
  CollapseHeader,
} from "accordion-collapse-react-native";
import { Image, ScrollView, Text, TouchableOpacity, View } from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import HeaderTabs from "../../components/HeaderTabs";
import api from "../../services/api";
import { If, Then, Else } from "react-if";
import styles from "./style";
import { FormattedMessage, useIntl } from "react-intl";
import translationService from "../../services/translationService";

export default function Exchange({ navigation }) {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const intl = useIntl();
  const carregandoLabel = intl.formatMessage({
    id: "exchange.carregandoMaiuscula",
  });
  const [clientCountry, setClientCountry] = useState(null);
  const [translatedCategories, setTranslatedCategories] = useState([]);

  const translateCategoryNames = async (categories) => {
    const language = await AsyncStorage.getItem("lang");

    try {
      const _translatedCategories = [];

      for (const category of categories) {
        const translatedCategory = { ...category }; // Copy the original object

        // Translate 'name' and 'description' at the root level
        const translatedName = await translationService.translate(
          category.name,
          language
        );
        const translatedDescription = await translationService.translate(
          category.description,
          language
        );
        translatedCategory.name = translatedName;
        translatedCategory.description = translatedDescription;

        // Translate 'name' and 'description' in the 'category' object
        if (category.category) {
          const translatedCategoryName = await translationService.translate(
            category.category.name,
            language
          );
          const translatedCategoryDescription =
            await translationService.translate(
              category.category.description,
              language
            );
          translatedCategory.category.name = translatedCategoryName;
          translatedCategory.category.description =
            translatedCategoryDescription;
        }

        _translatedCategories.push(translatedCategory);
      }

      setTranslatedCategories(_translatedCategories); // Update the state with the translated array
    } catch (error) {
      console.error("Error translating category names:", error);
    }
  };

  useEffect(() => {
    getCategories();
  }, []);

  useEffect(() => {
    const fetchCountry = async () => {
      const country = await AsyncStorage.getItem("client_country");
      setClientCountry(country);
    };

    fetchCountry();
  }, []);

  async function getCategories() {
    const token = await AsyncStorage.getItem("JWT_TOKEN");
    api
      .get("/categories", { headers: { Authorization: `Bearer ${token}` } })
      .then(async (response) => {
        const categories = response.data[0]
          .filter((item) => !item.adoption)
          .map((item) => {
            return {
              id: item.id,
              name: item.name,
              description: item.description,
              path: item.path,
            };
          });
        setCategories(categories);

        await translateCategoryNames(categories); // Adicione esta linha
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async function getClientDetails() {
    try {
      const token = await AsyncStorage.getItem("JWT_TOKEN");

      const res = await api.get(`/clients/getDetails/client`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const user = res.data.user[0];
      const client = user.client;

      return client;
    } catch (error) {
      console.error("Erro ao obter detalhes do cliente:", error);
    }
  }

  const ListActivesCategorie = ({ itemCategory }) => {
    const [activesList, setActivesList] = useState([]);
    const [expanded, setExpanded] = useState(false);

    async function getActivesByCategory(categoryId) {
      const token = await AsyncStorage.getItem("JWT_TOKEN");
      return api
        .get(`/actives/getActives/${categoryId}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          var listActives = response.data.active.map((item) => {
            return {
              id: item.id,
              name_token: item.name_token,
              path: item.path,
              single_value: item.single_value,
              cryptoactive: item.cryptoactive,
            };
          });
          return listActives;
        })
        .catch((error) => {
          console.error(error);
        });
    }

    useEffect(() => {
      (async () => {
        const list = await getActivesByCategory(itemCategory.id);
        setActivesList(list);
      })();
    }, [itemCategory]);

    return (
      <>
        <View style={styles.mainContainer}>
          <View style={styles.secondaryContainer}>
            <Collapse
              style={styles.category}
              isExpanded={expanded}
              onToggle={(isExpanded) => setExpanded(isExpanded)}
            >
              <CollapseHeader style={styles.categoryHeader}>
                <View style={styles.containerInfos}>
                  <Text style={styles.text1}>{itemCategory.name}</Text>
                  <Text style={styles.visualizarInformacao}>
                    <If condition={expanded}>
                      <Then>
                        <FormattedMessage id="exchange.ocultar" />
                      </Then>
                      <Else>
                        <FormattedMessage id="exchange.verInfos" />
                      </Else>
                    </If>
                  </Text>
                </View>
              </CollapseHeader>
              <CollapseBody style={styles.categoryBody}>
                <Text>{itemCategory.description}</Text>
              </CollapseBody>
            </Collapse>

            <ScrollView>
              <View style={styles.containerCardAtivo}>
                <If condition={activesList.length > 0}>
                  <Then>
                    {activesList.map((item) => (
                      <TouchableOpacity
                        key={item.id}
                        onPress={() => handleTokenView(item)}
                      >
                        <View style={styles.asset}>
                          <Image
                            source={{
                              uri: `https://filesgpx.s3.us-east-2.amazonaws.com/${item.path}`,
                            }}
                            style={styles.asset_icon}
                          />
                          <Text style={styles.asset_name}>
                            {item.name_token}
                          </Text>
                        </View>
                      </TouchableOpacity>
                    ))}
                  </Then>
                </If>
              </View>
            </ScrollView>
          </View>
        </View>
      </>
    );
  };

  const LoadingComponent = () => {
    return (
      <>
        <Text style={styles.txtCarregando}>
          <FormattedMessage id="exchange.carregando" />
        </Text>
      </>
    );
  };

  function handleTokenView(token) {
    navigation.navigate("Token", {
      id: token.id,
      name: token.name_token,
      name_token: token.name_token,
      path: token.path,
      single_value: token.single_value,
    });
  }

  return (
    <View style={{ marginBottom: 20 }}>
      <HeaderTabs
        title={"EXCHANGE"}
        iconLeft={"settings"}
        routeLeft={"MyAccount"}
        subtitle={<FormattedMessage id="exchange.subtitulo" />}
      />
      <ScrollView
        style={{
          position: "relative",
          zIndex: -99,
          elevation: 3,
          marginTop: 1,
        }}
      >
        <If condition={clientCountry === "brasil"}>
          <Then>
            <View style={styles.categoriasBtnsContainer}>
              <If condition={categories.length > 0}>
                <Then>
                  {translatedCategories.map((el) => {
                    if (
                      (el.name === "I-REC" && clientCountry !== "brasil") ||
                      el.name.includes("Selo")
                    ) {
                      return null;
                    }

                    const translatedCategory = translatedCategories[el.name];

                    return (
                      <TouchableOpacity
                        key={el.id}
                        style={
                          selectedCategory && selectedCategory.id === el.id
                            ? styles.selectedButton
                            : styles.btnsCategorias
                        }
                        onPress={() => setSelectedCategory(el)}
                      >
                        <Text
                          style={[
                            styles.categoryButtonText,
                            selectedCategory &&
                              selectedCategory.id === el.id &&
                              styles.categorySelectedBtnTxt,
                          ]}
                        >
                          {translatedCategory
                            ? translatedCategory.translatedName
                            : el.name}
                        </Text>
                      </TouchableOpacity>
                    );
                  })}
                </Then>
                <Else>
                  <Text style={styles.txtCarregando}>{carregandoLabel}</Text>
                </Else>
              </If>
            </View>
            <If condition={selectedCategory}>
              <Then>
                <ListActivesCategorie itemCategory={selectedCategory} />
              </Then>
            </If>
          </Then>

          <Else>
            <View style={styles.notAvailableContainer}>
              <Text style={styles.notAvailableText}>
                <FormattedMessage id="exchange.funcionalidadeNãoDisponivel"></FormattedMessage>
              </Text>
            </View>
          </Else>
        </If>
      </ScrollView>
    </View>
  );
}
